<template>
	<div class="page-header d-flex justify-center align-center">
		<v-card class="page-title d-flex flex-column justify-center flex-grow-1 mr-0 mr-sm-3" height="67" flat>
			<v-card-text class="px-3 py-0">
				<h2 class="textColor--text fs--18 fs-sm--20 fs-md--23 fw--700">{{ title }}</h2>
			</v-card-text>
		</v-card>
		<div v-if="!isPremium" class="promo-banner mt-3 mt-sm-0">
			<v-card class="px-0 py-0" height="67" @click="actions.subscribe">
				<img src="@/assets/images/banner/Premium-Banner.png" height="67px" width="100%" />
			</v-card>
		</div>
	</div>
</template>

<script>
import { computed } from '@vue/composition-api';
import store from '@/store';
import { useRouter } from '@core/utils';
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
	},

	setup() {
		const subTier = computed(() => store.state.app.subTier);
		const currentPlan = computed(() => store.state.app.subPlans.find(plan => plan.tier === subTier.value));

		const isPremium = computed(() => {
			return Number(subTier.value) < 1 ? false : true;
		});

		const { router } = useRouter();
		const Router = useRouter();

		const actions = {
			subscribe() {
				const path = Router.route.value.path;
				if (path !== '/premium') {
					router.push('/premium');
				}
			}
		}

		return {
			subTier,
			currentPlan,
			isPremium,
			store,

			actions
		}
	}
};
</script>

<style lang="scss" scoped>
.page-title {
	width: 100%;

	.v-card {
		.v-card__text {
			font-weight: bold;
			font-size: larger;
			color: #d9d6ee;
		}
	}
}

.promo-banner {
	flex: 1;
	min-width: 297px !important;
	max-width: 100% !important;

	@media screen and (max-width: 400px) {
		width: 100% !important;
	}
}

@media (max-width: 600px) {
  .page-header {
    flex-direction: column !important;
  }

  .page-title {
    width: 100% !important;
  }

  .promo-banner {
    min-width: 100% !important;
  }
}
</style>
